import React, { useState } from 'react';
import { Popup } from '../../../ui/popup/popup';

const buttonStyle: React.CSSProperties = {
    position: 'fixed',
    zIndex: 2147483003,
    padding: '0',
    margin: '0',
    border: 'none',
    bottom: '20px',
    right: '20px',
    maxWidth: '48px',
    width: '48px',
    maxHeight: '48px',
    height: '48px',
    borderRadius: '50%',
    background: '#f013f0',
    cursor: 'pointer',
    boxShadow:
        '0 1px 6px 0 rgba(0, 0, 0, 0.06), 0 2px 32px 0 rgba(0, 0, 0, 0.16)',
    transition:
        'transform 167ms cubic-bezier(0.33, 0, 0, 1)',
    boxSizing: 'content-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

const Facade = () => {
    const [popupShown, setPopupShown] = useState(false);

    const openPopup = () => {
        setPopupShown(true);
    };

    const closePopup = () => {
        setPopupShown(false);
    };

    return (
        <div>
            <button
                type="button"
                onClick={ openPopup }
                style={ buttonStyle }>
                <svg viewBox="0 0 28 32" width="24px" height="24px"><path d="M28 32s-4.714-1.855-8.527-3.34H3.437C1.54 28.66 0 27.026 0 25.013V3.644C0 1.633 1.54 0 3.437 0h21.125c1.898 0 3.437 1.632 3.437 3.645v18.404H28V32zm-4.139-11.982a.88.88 0 00-1.292-.105c-.03.026-3.015 2.681-8.57 2.681-5.486 0-8.517-2.636-8.571-2.684a.88.88 0 00-1.29.107 1.01 1.01 0 00-.219.708.992.992 0 00.318.664c.142.128 3.537 3.15 9.762 3.15 6.226 0 9.621-3.022 9.763-3.15a.992.992 0 00.317-.664 1.01 1.01 0 00-.218-.707z" fill="#fff"></path></svg>
            </button>

            {
                popupShown &&
                <Popup width="400px" height="270px" close={ closePopup }>
                    <div className="flex flex-col justify-center items-center w-full h-full my-4 text-center">
                        <p className="px-10">Please <a href="/legal/cookie-notice-and-privacy-choices#customize">enable Functional Technologies</a> to chat with us.</p>
                    </div>
                </Popup>
            }
        </div>
    )
};

export default Facade;